import React from 'react';
import { 
  Calculator, BookOpen, Globe, Bone, Clock, Rocket, 
  BookText, Shapes, Palette, Music, Trophy, UtensilsCrossed,
  Laptop, Paintbrush, Leaf
} from 'lucide-react';
import { playSound } from '../../utils/soundManager';
import { useLanguage } from '../../contexts/LanguageContext';

const categoryIcons = {
  math: Calculator,
  science: Bone,
  geography: Globe,
  animals: Bone,
  history: Clock,
  space: Rocket,
  english: BookText,
  shapes: Shapes,
  colors: Palette,
  music: Music,
  sports: Trophy,
  food: UtensilsCrossed,
  technology: Laptop,
  art: Paintbrush,
  nature: Leaf
};

const CategoryCard = ({ category, onSelect }) => {
  const Icon = categoryIcons[category.id] || BookOpen;
  const { t } = useLanguage();

  const handleClick = () => {
    playSound('click');
    onSelect(category.id);
  };

  return (
    <div 
      className="category-card hover-lift animate-scaleIn"
      onClick={handleClick}
      style={{
        borderTop: `4px solid ${category.color}`,
        cursor: 'pointer'
      }}
    >
      <div className="category-icon" style={{ color: category.color }}>
        <span className="category-emoji animate-bounce">{category.icon}</span>
        <Icon size={40} />
      </div>
      <h3 style={{ color: category.color }}>{t(`categories.${category.id}`)}</h3>
      <p>{t(`categoryDesc.${category.id}`)}</p>
      <button 
        className="start-button btn-press"
        style={{ background: category.color }}
      >
        {t('common.start')}
      </button>
    </div>
  );
};

export default CategoryCard;
